import {Link, useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin.module.css";
import FilterHamburgerCustom from "../../Filter/FilterHamburgerCustom";
import ActivitesTable from "./ActivitesTable";
import {
    ACTIVITE_STATUS_VALUE, ACTIVITES_STATUS,
    fetchToGetActivitesAdmin,
    fetchToSetActiviteActif,
    getActiviteApi, getActivitesStatusIcon, getActiviteStatus
} from "../../../services/ActivitesService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import TitleSecondary from "../../Title/TitleSecondary";
import SearchUtilisateur from "../../Search/SearchUtilisateur";
import SearchCoach from "../../Search/SearchCoach";
import Routing from "../../../services/routing";
import ErrorPage from "../../../pages/Erreurs/ErrorPage";
import styles_filter from "../../Filter/Filter.module.css";
import {getUtilisateurStatus, getUtilisateurStatusIcon, USER_STATUS_VALUE} from "../../../services/UserService";
import {updateFilterUri} from "../../../services/FilterService";

function ActivitesVue({}) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [activites, setActivites] = useState();
    const [entreprise, setEntreprise] = useState();
    const [contrat, setContrat] = useState();
    const {updateDynamicBreadcrumb} = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const {entrepriseId, contratId} = useParams();
    const utilisateur = searchParams.get('filter_utilisateur') || null;
    const coach = searchParams.get('filter_coach') || null;
    const deleted = searchParams.get('filter_deleted') || 'false';
    const status = searchParams.get('filter_status') || null;
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const submitUtilisateur = (values) => {
        queryParams.set('filter_utilisateur', values.id);
        navigate(`?${queryParams.toString()}`);
    }

    const submitCoach = (values) => {
        queryParams.set('filter_coach', values.id);
        navigate(`?${queryParams.toString()}`);
    }

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').dataset.key;
        queryParams.delete(key);
        navigate(`?${queryParams.toString()}`);
    }

    const submitActif = () => {
        queryParams.set('filter_deleted', deleted === "true" ? "false" : "true");
        navigate(`?${queryParams.toString()}`);
    }

    const submitStatus = (value) => {
        queryParams.set('filter_status', value);
        navigate(`?${queryParams.toString()}`);
    }

    const childrenOfFilter = (
        <div style={{display: "flex", flexDirection: "column", gap: "0px", margin: "35px", alignItems: "center"}}>
            <TitleSecondary text="Filtres"/>

            <div className={styles.filtersRemoveBar}>
                {/* Aficher tous les parametres de l'url commençant par filter_ */}
                {Array.from(queryParams.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        let lbl = value;
                        let cle = key.replace('filter_', '');
                        if (key === 'filter_status') {
                            cle = "Statut";
                            lbl = ACTIVITES_STATUS.find(ACTIVITE_STATUS_VALUE => ACTIVITE_STATUS_VALUE.value.toString() === value)?.label || value;
                        }

                        if (key === 'filter_deleted') {
                            cle = "Supprimées";
                            lbl = value === "true" ? "Oui" : "Non";
                        }

                        if (key === 'filter_utilisateur') {
                            cle = "Participant";
                            lbl = `${value}`;
                        }

                        if (key === 'filter_coach') {
                            cle = "Coach";
                            lbl = `${value}`;
                        }

                        return (
                            <button key={key} className={styles.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcone/>
                                <span className={"filter_key"} data-key={key}>{cle}</span> : {lbl}
                            </button>
                        );
                    })
                }
            </div>

            <div className={styles.formBloc} style={{ alignItems: "center" }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    padding: "12px 16px",
                    outline: "1px solid var(--clr-accent)",
                    borderRadius: "4px",
                    marginBottom: "16px",
                }}>
                    <span>Statut</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                    }}>
                        {
                            ACTIVITE_STATUS_VALUE && ACTIVITE_STATUS_VALUE.map((s, index) => {
                                return <button key={index} className={styles_filter.btnFiltre}
                                               onClick={() => submitStatus(s)}
                                >
                                    {getActivitesStatusIcon(s)} {getActiviteStatus(s)}
                                </button>
                            })}
                    </div>
                </div>

                <div>
                    Participant :
                    <SearchUtilisateur onSubmit={submitUtilisateur} entrepriseId={entrepriseId}/>
                </div>

                <div>
                    Coach :
                    <SearchCoach onSubmit={submitCoach}/>
                </div>

                <div style={{display: "flex", justifyContent: "center", marginTop: "20px"}}>
                    <button
                        className={`btn ${deleted === "true" ? "btn_success" : "btn_danger"}`}
                        type="button"
                        onClick={(e) => {
                            submitActif();
                        }}
                        disabled={false}
                    >
                        Afficher les activités {deleted === "true" ? "actives" : "supprimées"}
                    </button>
                </div>
            </div>
        </div>
    );

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const putActifOpenModal = (activite) => {
        const text = activite.actif ? "supprimer" : "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette activité ?`,
            onConfirm: async () => {
                const response = await fetchToSetActiviteActif({
                    activite: activite,
                    contratId: contratId,
                    entrepriseId: entrepriseId
                });
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(async () => {
                    const response = await fetchToGetActivitesAdmin({entrepriseId: entrepriseId, contratId: contratId});
                    setActivites(response?.myActivites);
                }, 500);
            }
        });
    }

    const handleSubmitContratDetailStatus = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/contrat_detail/${values.id}/status`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                setTimeout(async () => {
                    const response = await fetchToGetActivitesAdmin({entrepriseId: entrepriseId, contratId: contratId});
                    setActivites(response?.myActivites);
                }, 500);
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    useEffect(() => {
        const params = new URLSearchParams();
        if (utilisateur) params.append('utilisateur', utilisateur);
        if (coach) params.append('coach', coach);
        if (deleted) params.append('deleted', deleted);
        if (status) params.append('status', status);

        (async () => {
            const response = await fetchToGetActivitesAdmin({
                entrepriseId: entrepriseId,
                contratId: contratId,
                params: params.toString()
            });
            setActivites(response?.myActivites);
            setContrat(response?.myContrat);
            setEntreprise(response?.myEntreprise);
        })();
    }, [mode, utilisateur, coach, deleted, status]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({entreprise, contrat}));
    }, [entreprise, contrat]);

    if (!activites) {
        return "Page inaccessible";
    }

    return (
        <>
            <FilterHamburgerCustom onReinirFilters={
                () => {
                    const queryParams = new URLSearchParams(location.search);
                    Object.entries({
                        utilisateur: '',
                        coach: '',
                        deleted: '',
                        status: '',
                    }).forEach(([key, value]) => {
                        if (value) {
                            queryParams.append(`filter_${key}`, value);
                        } else {
                            if (queryParams.has(`filter_${key}`)) {
                                queryParams.delete(`filter_${key}`);
                            }
                        }
                    });
                    navigate(`?${queryParams.toString()}`);
                }
            } children={childrenOfFilter}/>

            <div className={styles.navLink}>
                <Link to={Routing.routes.adminCreation}>
                    <AjouterIcone/>
                    Ajouter une activité
                </Link>
            </div>

            {activites && <ActivitesTable activites={activites} entreprise={entreprise} contrat={contrat}
                                          putActifOpenModal={putActifOpenModal}
                                          handleSubmitContratDetailStatus={handleSubmitContratDetailStatus}/>}
        </>
    )
}

export default ActivitesVue;